import React from 'react';
import { useTranslation } from '@lt/localization';
import { Plane, Landing } from '@lt/components/icons-react/userflow';
import type {
  TransitionInfo,
  TransitionTimeInfo,
} from '@lt/api/dist/methods/packages/types';
import classNames from 'classnames';

import {
  getTransferCity,
  getTransferDuration,
  getTransferDates,
  getHoursSafe,
} from '../../../utils/flightUtils';
import styles from './FlightTransferInfo.module.css';

import FlightDaysDiff from '../FlightDaysDiff';

interface IFlightTransferInfo {
  transition?: TransitionInfo | null;
  transitionTime?: TransitionTimeInfo | null;
}

const FlightTransferInfo = ({
  transition = null,
  transitionTime = null,
}: IFlightTransferInfo) => {
  const { t } = useTranslation();
  const city = getTransferCity(transition);
  const duration = getTransferDuration(transitionTime);
  const { arrival, departure } = getTransferDates(transitionTime);

  return (
    <div>
      <div className={styles.textMargin}>
        {transitionTime !== null && (
          <span className={styles.timeText}>{duration}</span>
        )}
        {transitionTime !== null && <span> — </span>}
        {transition !== null ? (
          city
        ) : (
          <span>{t('checkout.flight.transfer.noCity')}</span>
        )}
        {transitionTime === null && (
          <p className={classNames(styles.bottomMarginP, styles.topMarginP)}>
            {t('checkout.flight.transfer.noTime')}
          </p>
        )}
        {transition === null || transitionTime === null ? null : <br />}
      </div>
      <div className={styles.iconsBlock}>
        {transitionTime !== null && <Landing className={styles.iconArrival} />}
        {arrival && departure ? (
          <span>
            {getHoursSafe(arrival)}−{getHoursSafe(departure)}
          </span>
        ) : null}
        <FlightDaysDiff
          className={styles.diff}
          previousDate={arrival}
          nextDate={departure}
        />
        {transitionTime !== null && <Plane className={styles.iconDeparture} />}
      </div>
    </div>
  );
};

export default FlightTransferInfo;
